import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navigation = [
  { name: '📊 Genel Bakış', href: '/' },
  { name: '👥 Kullanıcılar', href: '/users' },
  { name: '🔮 Burç Tarayıcı', href: '/zodiac' },
  { name: '💰 Gelir', href: '/revenue' },
  { name: '🗃️ Önbellek', href: '/caches' },
  { name: '📅 İçerik', href: '/content' },
  { name: '🔔 Bildirimler', href: '/notifications' },
  { name: '⚠️ Hata Logları', href: '/error-logs' },
];

export default function Layout({ children }) {
  const { admin, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="flex h-screen bg-slate-900">
      {/* Sidebar */}
      <div className="w-64 bg-slate-800 border-r border-slate-700 flex flex-col">
        <div className="p-4">
          <div className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-500 mb-8">
            AstroPro
          </div>

          <nav className="space-y-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={`block px-4 py-2 rounded-lg transition text-sm ${
                    isActive
                      ? 'bg-indigo-500 text-white'
                      : 'text-slate-300 hover:bg-slate-700'
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Push user info to bottom */}
        <div className="mt-auto p-4">
          <div className="bg-slate-700 rounded-lg p-3 mb-3">
            <p className="text-xs text-slate-400">Giriş yapan</p>
            <p className="text-sm font-semibold text-white truncate">{admin?.email}</p>
          </div>
          <button
            onClick={logout}
            className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition text-sm"
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-slate-800 border-b border-slate-700 px-6 py-4">
          <h1 className="text-xl font-bold text-white">Yönetim Paneli</h1>
        </header>

        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
